import { Lock } from "lucide-react";
import type { ReactNode } from "react";

export function PhoneFrame({ children, className = "" }: { children: ReactNode; className?: string }) {
  return (
    <div className={`relative rounded-[2.6rem] bg-[#15110E] p-2.5 shadow-2xl ${className}`}>
      <div className="flex h-full flex-col overflow-hidden rounded-[2.1rem] bg-background">{children}</div>
    </div>
  );
}

export function BrowserFrame({ url, children, className = "" }: { url: string; children: ReactNode; className?: string }) {
  return (
    <div className={`overflow-hidden rounded-2xl border border-border bg-card shadow-2xl ${className}`}>
      <div className="flex items-center gap-2 border-b border-border bg-muted/40 px-4 py-3">
        <span className="flex gap-1.5">
          <span className="h-2.5 w-2.5 rounded-full bg-[#E0685E]" />
          <span className="h-2.5 w-2.5 rounded-full bg-[#E8B04B]" />
          <span className="h-2.5 w-2.5 rounded-full bg-[#5FB37E]" />
        </span>
        <span className="mx-auto flex items-center gap-1.5 rounded-full bg-background px-3.5 py-1 text-xs font-medium text-muted-foreground">
          <Lock className="h-3 w-3" /> {url}
        </span>
      </div>
      {children}
    </div>
  );
}

const FLOW = [
  { w: "34%", c: "#3BA776" },
  { w: "24%", c: "hsl(var(--primary))" },
  { w: "16%", c: "#6E8BB8" },
  { w: "13%", c: "#C9A96A" },
  { w: "13%", c: "#8C82B6" },
];

export function BrowserBudgeAI() {
  return (
    <BrowserFrame url="budgeai.netlify.app/analytics">
      <div className="p-6">
        <div className="text-base font-bold text-foreground">Money Flow</div>
        <div className="mt-2 text-3xl font-extrabold tracking-tight text-foreground">€48,250.60</div>
        <div className="mt-4 flex h-4 w-full overflow-hidden rounded-md">
          {FLOW.map((f, i) => (
            <span key={i} style={{ width: f.w, background: f.c }} />
          ))}
        </div>
        <div className="mt-3 flex flex-wrap gap-3">
          {[
            { l: "Income", c: "#3BA776" },
            { l: "Housing", c: "hsl(var(--primary))" },
            { l: "Transport", c: "#6E8BB8" },
            { l: "Rest", c: "#8C82B6" },
          ].map((x) => (
            <span key={x.l} className="flex items-center gap-1.5 text-[11px] font-medium text-muted-foreground">
              <span className="h-2 w-2 rounded-full" style={{ background: x.c }} /> {x.l}
            </span>
          ))}
        </div>
        <div className="mt-6 h-24 rounded-xl bg-muted/40" />
      </div>
    </BrowserFrame>
  );
}
